import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a3e8060"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"profile-card-photo-wrapper\" data-v-2a3e8060><div class=\"profile-card__photo-skeleton skeleton\" data-v-2a3e8060></div></div><div class=\"profile-card__metro-skeleton skeleton\" data-v-2a3e8060></div><div class=\"profile-card__name-skeleton skeleton\" data-v-2a3e8060></div><div class=\"profile-card__price-skeleton skeleton\" data-v-2a3e8060></div>", 4)
const _hoisted_6 = { class: "profile-card-photo-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "profile-card__photo-skeleton skeleton"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 2,
  class: "profile-card__photo-stub stub"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stub__text" }, "Добавить превью", -1 /* HOISTED */))
const _hoisted_11 = { class: "profile-card__metro" }
const _hoisted_12 = { class: "profile-card__name" }
const _hoisted_13 = { class: "profile-card__price" }

import { computed, ComputedRef, PropType } from "vue";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";
import ProfileIcon from "@/common/icons/ProfileIcon.vue";
import CloseBigIcon from "./icons/CloseBigIcon.vue";
import {cityPathMap} from "@/searchSection/types/ECities";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCard',
  props: {
  card: {
    type: Object as PropType<ProfileCardInterface>,
    required: true,
  },
  close: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ['action-close'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "4b370c12": (getMetroColor.value)
}))

const props = __props

const emits = __emit

const linkProfile = computed<string>(() => {
  let cityUrl = ''
  if (props.card?.cityId !== 1) {
    cityUrl = `/${cityPathMap[props.card?.cityId]}`
  }
  return `${cityUrl}/escort/${props.card.id}`
})

const getMetroName: ComputedRef<string> = computed(() => {
  if (props.card.metroStations.length !== 0) {
    return props.card?.metroStations[0].name;
  }
  return '';
})

const getMetroColor: ComputedRef<string> = computed(() => {
  if (props.card.metroStations.length !== 0) {
    return '#' + (props.card?.metroStations[0].color || 'fff');
  }
  return '';
})

const getFirstPhoto: ComputedRef<string | undefined> = computed(() => {  
  if (props.card.photosSmall.length !== 0) {
    if (props.card.photosSmall[0].includes('blob')) {
      return props.card.photosSmall[0];
    }

    return '/assets/uploads/photos/' + props.card.photosSmall[0];
  }

  return undefined;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "profile-card",
    target: "_blank",
    href: linkProfile.value
  }, [
    (__props.close)
      ? (_openBlock(), _createBlock(CloseBigIcon, {
          key: 0,
          class: "profile-card__close",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emits('action-close', __props.card.id)), ["prevent"]))
        }))
      : _createCommentVNode("v-if", true),
    (__props.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_2
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_6, [
            (__props.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : (getFirstPhoto.value && !__props.loading)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "profile-card__photo",
                    src: getFirstPhoto.value,
                    alt: "photo"
                  }, null, 8 /* PROPS */, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(ProfileIcon, { class: "stub__icon" }),
                    _hoisted_10
                  ]))
          ]),
          _createElementVNode("p", _hoisted_11, _toDisplayString(getMetroName.value), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_12, _toDisplayString(__props.card.name), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_13, _toDisplayString(__props.card.priceInfo), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
  ], 8 /* PROPS */, _hoisted_1))
}
}

})